import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function infrastructuurReducer(state = initialState.infrastructuren, action) {
	switch (action.type) {
		case types.INFRASTRUCTUREN_BY_DOSSIER_LOADED: {
			return Object.assign([], action.body.items);
		}
		default:
			return state;
	}
}
